import script from "./FinishedSetup.vue?vue&type=script&setup=true&lang=ts"
export * from "./FinishedSetup.vue?vue&type=script&setup=true&lang=ts"

import "./FinishedSetup.vue?vue&type=style&index=0&id=47c5cfca&lang=scss"

const __exports__ = script;

export default __exports__